var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicenseDraftSolidStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.50014 3.99997C1.50015 2.34313 2.8433 1 4.50014 1H17.5C19.1568 1 20.5 2.34315 20.5 4V11.9837C19.6585 11.5663 18.61 11.708 17.909 12.409L11.909 18.409C11.4871 18.831 11.25 19.4033 11.25 20V23H4.5C2.84313 23 1.49999 21.6568 1.5 20L1.50014 3.99997ZM7 5C6.44772 5 6 5.44772 6 6C6 6.55228 6.44772 7 7 7H15C15.5523 7 16 6.55228 16 6C16 5.44772 15.5523 5 15 5H7ZM7 10C6.44772 10 6 10.4477 6 11C6 11.5523 6.44772 12 7 12H15C15.5523 12 16 11.5523 16 11C16 10.4477 15.5523 10 15 10H7Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7929 13.2929C19.1834 12.9024 19.8166 12.9024 20.2071 13.2929L22.2071 15.2929C22.5976 15.6834 22.5976 16.3166 22.2071 16.7071L16.2071 22.7071C16.0196 22.8946 15.7652 23 15.5 23H13.5C12.9477 23 12.5 22.5523 12.5 22V20C12.5 19.7348 12.6054 19.4804 12.7929 19.2929L18.7929 13.2929Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicenseDraftSolidStandard);
export default __webpack_public_path__ + "static/media/license-draft-solid-standard.d6754dee1b58768f006e181ed61ca972.svg";
export { ForwardRef as ReactComponent };